module.exports = {
    AUTH_TYPE: {
        REAUTH: 'reauthorize',
        REREQUEST: 'rerequest'
    },
    LOGIN_STATUS: {
        CONNECTED: 'connected',
        AUTH_EXPIRED: 'authorization_expired',
        NO_AUTH: 'not_authorized'
    },
    PERMISSION_STATUS: {
        GRANTED: 'granted',
        DECLINED: 'declined'
    }
};



// WEBPACK FOOTER //
// ./app/scripts/constants/facebook.js